import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import authSvc from "../../services/auth-service";
import { useDispatch } from "react-redux";
import { login, setUser } from "../../redux/authSlice";

const ForgotPasswordForm = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [forgotPasswordStep, setForgotPasswordStep] = useState(1);
  const [otpVerified, setOtpVerified] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const emailVerification = async (e) => {
    e.preventDefault();
    const emailOtp = await authSvc.recieveOTP(email);
    if (emailOtp) {
      setForgotPasswordStep(2);
    }
  };

  const otpVerification = async (e) => {
    e.preventDefault();
    const otpVerification = await authSvc.confirmOTP(email, otp);
    if (otpVerification) {
      setForgotPasswordStep(3);
    }
  };

  const resetPassword = async (e) => {
    e.preventDefault();
    if (password === confirmPassword) {
      const passwordChanged = await authSvc.changeForgetPassword(
        email,
        password
      );
      if (passwordChanged) {
        navigate("/");
      }
    }
  };

  return (
    <>
      {forgotPasswordStep === 1 ? (
        <form className="customForm" onSubmit={(e) => emailVerification(e)}>
          <div className="title">
            <h2>Reset Password</h2>
            <p>
              Enter your email <br /> to reset you password!
            </p>
          </div>
          <div className="fieldset mb-4">
            <label htmlFor="check"></label>
            <Form.Group>
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                required
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
          </div>
          <button className="w-100 btn cta-primary">Reset Password</button>
        </form>
      ) : forgotPasswordStep === 2 ? (
        <form className="customForm" onSubmit={(e) => otpVerification(e)}>
          <div className="title">
            <h2>Reset Password</h2>
            <p>
              Enter your <br /> verification code
            </p>
          </div>
          <div className="fieldset mb-4">
            <label htmlFor="check"></label>
            <Form.Group>
              <Form.Label>Enter code</Form.Label>
              <Form.Control
                type="text"
                required
                placeholder="Code"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
            </Form.Group>
          </div>
          <button className="w-100 btn cta-primary">Verify Otp</button>
        </form>
      ) : (
        <form className="customForm" onSubmit={(e) => resetPassword(e)}>
          <div className="title">
            <h2>Reset Password</h2>
            <p>
              Verify your <br /> verification code
            </p>
          </div>
          <div className="fieldset mb-3">
            <i onClick={() => setShowPassword(!showPassword)}>
              {!showPassword ? (
                <Icon icon="clarity:eye-line" />
              ) : (
                <Icon icon="clarity:eye-hide-line" />
              )}
            </i>
            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="fieldset mb-3">
            <i onClick={() => setShowPassword(!showPassword)}>
              {!showPassword ? (
                <Icon icon="clarity:eye-line" />
              ) : (
                <Icon icon="clarity:eye-hide-line" />
              )}
            </i>
            <Form.Group>
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>
          </div>
          <button className="w-100 btn cta-primary">Reset Password</button>
        </form>
      )}
    </>
  );
};

export default ForgotPasswordForm;
